import { Receipt } from "lucide-react";
import { formatBankAccount, formatDate } from "~/lib/format";
import { getVatVerificationPresentation } from "~/lib/vat-verification";
import type { CompanyProfile } from "~/types/company";
import { CardFooterLink, DataRow, OverviewCard } from "./card";

/** ⑦ DPH — registration summary + FÚ + published bank accounts, links to /dph. */
export function VatCard({ company }: { company: CompanyProfile }) {
	const vat = company.vatRegistration;
	if (!vat) return null;

	const accounts = vat.bankAccounts ?? [];
	const verification = getVatVerificationPresentation(vat);

	return (
		<OverviewCard
			icon={Receipt}
			title="DPH"
			trailing={<span className={verification.className}>{verification.label}</span>}
		>
			<dl className="flex flex-col gap-3 text-sm">
				<DataRow label="DIČ" value={vat.dic} mono />
				<DataRow label="Plátce DPH" value={vat.isVatPayer ? "Ano" : "Ne"} />
				{vat.registeredAt && <DataRow label="Registrace od" value={formatDate(vat.registeredAt)} />}
				{vat.taxOfficeCode && (
					<DataRow label="Finanční úřad" value={`FÚ kód ${vat.taxOfficeCode}`} />
				)}
				{accounts.length > 0 && (
					<DataRow
						label="Zveřejněné účty"
						value={
							<span className="flex flex-col gap-0.5">
								{accounts.map((account) => (
									<span key={`${account.prefix ?? ""}-${account.number}`} className="font-mono">
										{formatBankAccount(account)}
									</span>
								))}
							</span>
						}
					/>
				)}
			</dl>
			<CardFooterLink to="dph">Detail registrace DPH</CardFooterLink>
		</OverviewCard>
	);
}
